export function formatDate(dateString) {
    try {
      const date = new Date(dateString)
      const options = { day: 'numeric', month: 'short', year: 'numeric' }
      return date.toLocaleDateString('en-US', options)
    } catch (error) {
      // console.error(error)
      return 'Invalid Date'
    }
}